// tslint:disable:no-unsafe-any (autogenerated)
// tslint:disable:no-any (autogenerated)
import BaseStore from '../../components/base/base-store';

export interface IWindowSizeStoreState {
    width: number;
    height: number;
    resizing: boolean;
}

class WindowSizeStore extends BaseStore<IWindowSizeStoreState> {
    // tslint:disable-next-line:typedef (autogenerated)
    public static defaultDimensions = { width: 1024, height: 800 };

    // tslint:disable-next-line:typedef (autogenerated)
    public static minimumDimensions = { width: 300, height: 300 };

    public dispatcherEvents: string = 'setWindowSize';
    public initialState: any = WindowSizeStore.defaultDimensions;
    private afterResizeTimeout: number;

    constructor() {
        super();
        if (typeof window !== 'undefined') {
            window.addEventListener('resize', this.updateSize);
            this.initialState = WindowSizeStore.getSize();
            this.initialState.resizing = false;
        }
        this.initialize('WindowSizeStore');
    }

    // tslint:disable-next-line:typedef (autogenerated)
    public static getSize() {
        const width = Math.max(
            window.innerWidth || WindowSizeStore.defaultDimensions.width,
            WindowSizeStore.minimumDimensions.width
        );
        const height = Math.max(
            window.innerHeight || WindowSizeStore.defaultDimensions.height,
            WindowSizeStore.minimumDimensions.height
        );
        return { width, height, resizing: true };
    }

    // tslint:disable-next-line:member-access (autogenerated)
    finishResize = () => {
        this.updateState({ resizing: false });
    };

    // tslint:disable-next-line:member-access (autogenerated)
    updateSize = () => {
        this.updateState(WindowSizeStore.getSize());
        window.clearTimeout(this.afterResizeTimeout);
        this.afterResizeTimeout = window.setTimeout(this.finishResize, 100);
    };
}

const store = new WindowSizeStore();
// tslint:disable-next-line:no-default-export (autogenerated)
export default store;
